import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ListIconArrowDown from "../../../styles/images/png/ListIconArrowDown.png";
import ListIconArrowUp from "../../../styles/images/png/ListIconArrowUp.png";
import Link from "@mui/material/Link";
import { Link as ReactRouterLink } from "react-router-dom";
import {
     DashboardIcon,
     ParticipantsIcon,
     HomeContentIcon,
     IncentivesIcon,
     CommunicationsIcon,
     DataManagementIcon,
     NewsFeedIcon,
     MessagingIcon,
     ReportsIcon,
     VoucherManagementIcon
} from "../../../styles/images/svg/DashboardIcons";
import { IncentiveActiveIcon } from "../../../styles/images/svg/IncentiveActiveIcon";
import { Tooltip } from "@mui/material";
import {  useContext } from "react";
import {Context} from "../../../_context/Store";

export const SidebarMenu = (props) => {
     const [isToggle, setToggle] = React.useState(null);
     const [isSubToggle, setSubToggle] = React.useState(null);
     const [innerLink, setInnerLink] = React.useState(null);
     const [isCollapse, setCollapse] = React.useState(false);
     const { open } = props;
     const [subOpen, setSubopen] = useState(false);
     const [state, dispatch] = useContext(Context);

   

     const handleInnerSubNav = (clickedIndex) => {
          if (innerLink === clickedIndex) {
               setInnerLink(null);
          } else {
               setInnerLink(clickedIndex);
          }
     };

     const renderTooltip = (children, title) => {
          return open ? (
               children
          ) : (
               <Tooltip title={title} placement="right" arrow>
                    {children}
               </Tooltip>
          );
     };

     const handleSubNav = (clickedIndex) => {
          if (isSubToggle === clickedIndex) {
               setSubToggle(null);
               setSubopen(false);
          } else {
               setSubToggle(clickedIndex);
               setSubopen(true);
          }
     };
    

     const navs = [
          {
               id: 1,
               name: "Dashboards",
               icon: <DashboardIcon />,
               activeicon: <DashboardIcon />,
               to: "/app/dashboard",
               items: [],
          },
          // {
          // 	id: 2,
          // 	name: 'Locations',
          // 	icon: <LocationIcon />,
          // 	activeicon: <LocationIcon />,
          // 	to: '/ui/locations',
          // 	items: [
          // 		{
          // 			name: 'Manage Locations',
          // 			to: '/ui/locations',
          // 		},
          // 	],
          // },

          // {
          //      id: 2,
          //      name: "Featured Content",
          //      icon: <HomeContentIcon />,
          //      activeicon: <HomeContentIcon />,
          //      items: [
          //           {
          //                name: "Home",
          //                to: "/ui/locations",
          //                innerItems: [],
          //           },
          //           {
          //                name: "Incentives",
          //                to: "/ui/locations",
          //                innerItems: [],
          //           },
          //           {
          //                name: "Shop",
          //                to: "/ui/locations",
          //                innerItems: [],
          //           },
          //      ],
          // },
          {
               id: 3,
               name: "Incentive Campaign",
               icon: <IncentivesIcon />,
               activeicon: <IncentiveActiveIcon />,
               to: "/app/incentive-data-manage",
               items: [],
          },
          // {
          //      id: 4,
          //      name: "Newsfeed",
          //      icon: <NewsFeedIcon  />,
          //      activeicon: <NewsFeedIcon  />,
          //      to: "/ui/locations",
          //      items: [],
          // },
          // {
          //      id: 5,
          //      name: "Communications",
          //      icon: <CommunicationsIcon />,
          //      activeicon: <CommunicationsIcon />,
          //      to: "/ui/locations",
          //      items: [],
          // },
          // {
          //      id: 6,
          //      name: "Messaging",
          //      icon: <MessagingIcon />,
          //      activeicon: <MessagingIcon/>,
          //      to: "/ui/manage-marcoms",
          //      items: [],
          // },
          {
               id: 7,
               name: "Reports",
               icon: <ReportsIcon />,
               activeicon: <ReportsIcon />,
               to: "/app/reports",
               items: [],
          },
          {
               id: 8,
               name: "Sales Management",
               icon: <DataManagementIcon />,
               activeicon: <DataManagementIcon />,
               to: "/app/sales-data-manage",
               items: [],
          },
          {
               id: 9,
               name: "Participant Management",
               icon: <ParticipantsIcon />,
               activeicon: <ParticipantsIcon />,
               items: [
                    {
                         name: "Areas",
                         to: "/app/areas",
                         innerItems: [],
                    },
                    {
                         name: "Dealers",
                         to: "/app/dealers",
                         innerItems: [],
                    },
                    {
                         name: "Participants",
                         to: "/app/participants",
                         innerItems: [],
                    },
               ],
          },
          // {
          //      id: 9,
          //      name: "User Management",
          //      icon: <ParticipantsIcon />,
          //      activeicon: <ParticipantsIcon />,
          //      items: [
          //           {
          //                name: "Participants",
          //                to: "/app/participant",
          //                innerItems: [],
          //           },
          //           {
          //                name: "Participants Managers",
          //                to: "/app/participant",
          //                innerItems: [],
          //           },
          //           {
          //                name: "Admins",
          //                to: "/app/participant",
          //                innerItems: [],
          //           },
          //      ],
          // },

          {
               id: 10,
               name: "Sales Management",
               icon: <DataManagementIcon />,
               activeicon: <DataManagementIcon />,
               items: [
                    {
                         name: "Data Model",
                         innerItems: [
                              {
                                   name: "Lookup Table",
                                   to: "/app/lookup-data-manage",
                              },
                              {
                                   name: "Fact Table",
                                   to: "/app/fact-data-manage",
                              },
                             
                         ],
                    },
                    {
                         name: "Data Template",
                         to: "/app/data-templates-manage",
                         innerItems: [],
                    },
                    
                    {
                         name: "Sales Data Upload Center",
                         to: "/app/data-upload",
                         innerItems: [],
                    },
               ],
          },

          {
               id: 12,
               name: "Retail Sales Incentive",
               icon: <IncentivesIcon />,
               activeicon: <IncentivesIcon />,
               items: [
                    {
                         name: "Winners",
                         to: "/app/retail-sales-winners",
                         innerItems: [],
                    },
                    {
                         name: "Add Winners",
                         to: "/app/retail-sales-winners/add",
                         innerItems: [],
                    },
                    {
                         name: "Dealers",
                         to: "/app/retail-sales-dealers",
                         innerItems: [],
                    },
                    {
                         name: "Job Titles",
                         to: "/app/retail-sales-job-titles",
                         innerItems: [],
                    },
                    {
                         name: "Activation Report",
                         to: "/app/retail-sales-report",
                         innerItems: [],
                    },
               ],
          },

          {
               id: 13,
               name: "LCV",
               icon: <IncentivesIcon />,
               activeicon: <IncentivesIcon />,
               items: [
                    {
                         name: "Participant Upload",
                         to: "/app/lcv-participant-upload",
                         innerItems: [],
                    },
                    {
                         name: "Order Upload",
                         to: "/app/lcv-order-upload",
                         innerItems: [],
                    },
                    {
                         name: "Prize Pot",
                         to: "/app/lcv-prize-pot",
                         innerItems: [],
                    },
                    {
                         name: "Physical Prizes",
                         to: "/app/lcv-physical-prizes",
                         innerItems: [],
                    },
                    {
                         name: "Dealer Report",
                         to: "/app/lcv-dealer-report",
                         innerItems: [],
                    },
                    {
                         name: "Game Report",
                         to: "/app/lcv-game-report",
                         innerItems: [],
                    },
               ],
          },

          {
               id: 15,
               name: "Optimum Friction",
               icon: <IncentivesIcon />,
               activeicon: <IncentivesIcon />,
               items: [
                    {
                         name: "Training Accreditation",
                         to: "/app/optimum-friction-accreditation",
                         innerItems: [],
                    },
                    {
                         name: "Report",
                         to: "/app/optimum-friction-report",
                         innerItems: [],
                    },
               ],
          },
          {
               id: 14,
               name: "CX Always in Touch",
               icon: <IncentivesIcon />,
               activeicon: <IncentivesIcon />,
               items: [
                    {
                         name: "Winners",
                         to: "/app/cx-always-in-touch-winners",
                         innerItems: [],
                    },
                    {
                         name: "Add Winners",
                         to: "/app/cx-always-in-touch-winners/add",
                         innerItems: [],
                    },
                    {
                         name: "Activation Report",
                         to: "/app/cx-always-in-touch-report",
                         innerItems: [],
                    },
               ],
          },

          // {
          //      id: 11,
          //      name: "Voucher Management",
          //      icon: < VoucherManagementIcon />,
          //      activeicon: <VoucherManagementIcon/>,
          //      to: "/ui/voucher-management",
          //      items: [],
          // },
     ];

     const handleClick = (elm,clickedIndex) => {
          if(elm.items.length > 0){
               dispatch({ type: "SIDEBAR_MENU_OPEN", payload: true }); 
               dispatch({ type: "SIDEBAR_TOGGLE", payload: true }); 
          }
         
          if (isToggle === clickedIndex) {
               setToggle(null);
          } else {
               setToggle(clickedIndex);
          }
          
     };
     return (
          <>
               {navs.map((elm, index) => {
                    return (
                         <div
                              className="sbt-dashboard-sidebar__item"
                              
                         >
                              <ListItem
                                   disablePadding
                                   sx={{ display: "block" }}
                                   key={index}
                              >
                                   {renderTooltip(
                                        <ListItemButton
                                             sx={{
                                                  minHeight: 48,
                                             }}
                                             onClick={() => handleClick(elm,index)}
                                             component={ReactRouterLink}
                                             to={elm.to}
                                             key={index}
                                        >
                                             <ListItemIcon
                                                  sx={{
                                                       minWidth: 0,
                                                       mr: open ? 3 : "auto",
                                                       width:'25px'
                                                  }}
                                             >
                                                  {isToggle === index
                                                       ? elm.activeicon
                                                       : elm.icon}
                                             </ListItemIcon>

                                             <ListItemText
                                                  primary={elm.name}
                                                  sx={{
                                                       opacity: open ? 1 : 0,
                                                       color:
                                                            isToggle === index
                                                                 ? "red"
                                                                 : "",
                                                  }}
                                             />
                                             {elm.items.length > 0 && open ? (
                                                  isToggle === index ? (
                                                       <img
                                                            src={
                                                                 ListIconArrowUp
                                                            }
                                                       />
                                                  ) : (
                                                       <img
                                                            src={
                                                                 ListIconArrowDown
                                                            }
                                                       />
                                                  )
                                             ) : (
                                                  ""
                                             )}

                                             {/* {open ? renderArrowIcon(index, elm.showArrows) : ""} */}
                                        </ListItemButton>,
                                        elm.name,
                                   )}

                                   <>
                                        {elm.items.map(
                                             (element, elementIndex) => {
                                                  return (
                                                       <>
                                                            <Collapse
                                                                 key={
                                                                      elementIndex
                                                                 }
                                                                 in={
                                                                      open &&
                                                                      isToggle ===
                                                                           index
                                                                 }
                                                                 timeout="auto"
                                                                 unmountOnExit
                                                                 sx={{
                                                                      background:
                                                                           "#ebe9e9",
                                                                      borderBottom:
                                                                           "2px solid white",
                                                                 }}
                                                            >
                                                                 <List
                                                                      component="div"
                                                                      disablePadding
                                                                      key={
                                                                           elementIndex
                                                                      }
                                                                 >
                                                                      <ListItemButton
                                                                           sx={{
                                                                                pl: 8,
                                                                           }}
                                                                           component={
                                                                                ReactRouterLink
                                                                           }
                                                                           onClick={() =>
                                                                                handleSubNav(
                                                                                     elementIndex,
                                                                                )
                                                                           }
                                                                           to={
                                                                                element.to
                                                                           }
                                                                      >
                                                                           <ListItemText
                                                                                primary={
                                                                                     element.name
                                                                                }
                                                                                sx={{
                                                                                     color:
                                                                                          isSubToggle ===
                                                                                          elementIndex
                                                                                               ? "red"
                                                                                               : "",
                                                                                }}
                                                                           />

                                                                           {element
                                                                                .innerItems
                                                                                .length >
                                                                           0 ? (
                                                                                subOpen &&
                                                                                isSubToggle ===
                                                                                     elementIndex ? (
                                                                                     <img
                                                                                          src={
                                                                                               ListIconArrowUp
                                                                                          }
                                                                                     />
                                                                                ) : (
                                                                                     <img
                                                                                          src={
                                                                                               ListIconArrowDown
                                                                                          }
                                                                                     />
                                                                                )
                                                                           ) : (
                                                                                ""
                                                                           )}
                                                                      </ListItemButton>
                                                                 </List>
                                                                 <Collapse
                                                                      in={
                                                                           subOpen &&
                                                                           isSubToggle ===
                                                                                elementIndex
                                                                      }
                                                                      timeout="auto"
                                                                      unmountOnExit
                                                                      sx={{
                                                                           background:
                                                                                "#f4f4f4",
                                                                      }}
                                                                 >
                                                                      {element.innerItems &&
                                                                           element.innerItems.map(
                                                                                (
                                                                                     eleData,
                                                                                     innerIndex,
                                                                                ) => {
                                                                                     return (
                                                                                          <>
                                                                                               <List
                                                                                                    component="div"
                                                                                                    disablePadding
                                                                                                    key={
                                                                                                         innerIndex
                                                                                                    }
                                                                                               >
                                                                                                    <ListItemButton
                                                                                                         sx={{
                                                                                                              pl: 8,
                                                                                                         }}
                                                                                                         component={
                                                                                                              ReactRouterLink
                                                                                                         }
                                                                                                         to={
                                                                                                              eleData.to
                                                                                                         }
                                                                                                    >
                                                                                                         <ListItemText
                                                                                                              primary={
                                                                                                                   eleData.name
                                                                                                              }
                                                                                                              onClick={() =>
                                                                                                                   handleInnerSubNav(
                                                                                                                        innerIndex,
                                                                                                                   )
                                                                                                              }
                                                                                                              sx={{
                                                                                                                   color:
                                                                                                                        innerLink ===
                                                                                                                        innerIndex
                                                                                                                             ? "red"
                                                                                                                             : "",
                                                                                                              }}
                                                                                                         />
                                                                                                    </ListItemButton>
                                                                                               </List>
                                                                                          </>
                                                                                     );
                                                                                },
                                                                           )}
                                                                 </Collapse>
                                                            </Collapse>
                                                       </>
                                                  );
                                             },
                                        )}
                                   </>
                              </ListItem>
                         </div>
                    );
               })}
          </>
     );
};
